import React, {forwardRef, Fragment, useImperativeHandle, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {Button, Dialog, DialogTitle, Grid, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import {Delete} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import EmployeeService from "@/services/hr/EmployeeService";
import {useSnackbar} from "notistack";
import {CancelButton, SavingButton} from "@/components/data-grid/CustomButton";
import SnackbarUtil from "@/utils/SnackbarUtil";
import ActionButton from "@/components/actions/ActionButton";

const dialogStyle = {
  '& .MuiPaper-root': {width: '400px', top: '1vh', overflowX: "hidden"},
  '.MuiDialog-paper': {maxWidth: '100vw'},
  overflowX: "hidden",
};

export function DeleteAction({setInfo}: any) {
  const {t} = useTranslation()

  return (
    <ActionButton
      title={t("common.delete")}
      icon="icon-ic_delete"
      handleClick={() => {
        setInfo(true);
      }}
    >
    </ActionButton>
  )
}

const EmpDelete = (props: any, ref: any) => {
  const [info, setInfo] = useState<boolean>(false)
  const [empIds, setEmpIds] = useState<any>([])
  const {t} = useTranslation()
  const {enqueueSnackbar} = useSnackbar();
  const [isLoading, setLoading] = useState<boolean>(false);
  useImperativeHandle(ref, () => ({
    showDelete: async (id:string) => {
      setEmpIds({id})
      setInfo(false)
    }
  }));
  const toggleDrawer =
    (open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (empIds.length == 0 || empIds.id.length == 0) {
          setInfo(false);
          SnackbarUtil.error(t("att.schedule.Select person first"), {anchorOrigin: {vertical: 'top', horizontal: 'center'}})
          return;
        }
      };

  const onSubmit = async (event: any) => {
    try {
      setLoading(true)
      const promises = empIds?.id.map(async (emp: any) => {
        const res = await EmployeeService.destroy(emp.toString())
        if (res.status === 200) {
          enqueueSnackbar(t("common.success"), {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          });
          return true;
        }
        return false;
      }) || [];
      await Promise.all(promises);
      if (props.reloadTable) {
        props.reloadTable()
      }
    } catch (e) {
      console.log("error===", e)
    } finally {
      setInfo(false)
      setLoading(false)
    }
  }

  return (
    <Fragment>
      <Grid item={true} onClick={toggleDrawer(true)}>
        <DeleteAction setInfo={setInfo}/>
      </Grid>
      {/*<DeleteEmpDialog info={info} setInfo={setInfo} empIds={props.empIds}/>*/}
      <Dialog
        open={info}
        // onClose={()=>setInfo(false)}
        sx={dialogStyle}
      >
        <DialogTitle>
          {t("common.Delete Employee")}
          <IconButton
            aria-label="close"
            onClick={() => setInfo(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <CloseIcon/>
          </IconButton>
        </DialogTitle>
        <Typography sx={{textAlign: "center"}}>
          {t('common.deleteConfirm')}
        </Typography>
        <Grid style={{'padding': '20px'}}>
          <Stack spacing={3} direction={"row"} justifyContent="flex-end">
            <CancelButton onClick={() => {
              setInfo(false)
            }}/>
            <SavingButton loading={isLoading} onClick={onSubmit} children={t('common.confirm')}/>
          </Stack>
        </Grid>
      </Dialog>
    </Fragment>
  )
}

export default forwardRef(EmpDelete);
